module.exports = __WEBPACK_EXTERNAL_MODULE_tabby_settings__;